<section class="auction-inventory mt-4">
  <div class="container-fluid">
    <!-- start -->
    <div class="row mx-2 my-3">
      <!-- Make -->
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
        <label for="make">Make</label>
        <select
          id="make"
          class="form-control"
          name="Make"
          (change)="searchProductsFromList($event)"
        >
          <option value="" disabled selected>Please select make</option>
          <ng-container *ngFor="let item of makes | keyvalue; index as i">
            <option value="{{ item.key }}">
              {{ item.key }} ({{ item.value }})
            </option>
          </ng-container>
        </select>
      </div>

      <!-- Model -->
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
        <label for="model">Model</label>
        <select
          id="model"
          class="form-control"
          name="Model"
          (change)="searchProductsFromList($event)"
        >
          <option value="" disabled selected>Please select model</option>
          <ng-container *ngFor="let item of models | keyvalue; index as i">
            <option value="{{ item.key }}">
              {{ item.key }} ({{ item.value }})
            </option>
          </ng-container>
        </select>
      </div>

      <!-- Trim/Type -->
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
        <label for="trim-type">Trim/Type</label>
        <select
          id="trim-type"
          class="form-control"
          name="Trim/Type"
          (change)="searchProductsFromList($event)"
        >
          <option value="" disabled selected>Please select trim/type</option>
          <ng-container *ngFor="let item of trimType | keyvalue; index as i">
            <option value="{{ item.key }}">
              {{ item.key }} ({{ item.value }})
            </option>
          </ng-container>
        </select>
      </div>

      <!-- Model Year -->
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
        <label for="model-year">Model Year</label>
        <select
          id="model-year"
          class="form-control"
          name="Model Year"
          (change)="searchProductsFromList($event)"
        >
          <option value="" disabled selected>Please select model year</option>
          <ng-container *ngFor="let item of modelYears | keyvalue; index as i">
            <option value="{{ item.key }}">
              {{ item.key }} ({{ item.value }})
            </option>
          </ng-container>
        </select>
      </div>

      <!-- Exterior Color -->
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
        <label for="exterior-color">Exterior Color</label>
        <select
          id="exterior-color"
          class="form-control"
          name="Exterior Colour"
          (change)="searchProductsFromList($event)"
        >
          <option value="" disabled selected>
            Please select exterior color
          </option>
          <ng-container
            *ngFor="let item of exteriorColor | keyvalue; index as i"
          >
            <option value="{{ item.key }}">
              {{ item.key }} ({{ item.value }})
            </option>
          </ng-container>
        </select>
      </div>

      <!-- Status -->
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
        <label for="active-inactive-status">Status</label>
        <select
          id="active-inactive-status"
          class="form-control"
          name="active"
          (change)="searchProductsFromList($event)"
        >
          <option value="" disabled selected>Please select status</option>
          <option value="{{ true }}">Active</option>
          <option value="{{ false }}">Inactive</option>
        </select>
      </div>

      <!-- VIN -->
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
        <label for="vin-number">VIN</label>
        <input
          type="text"
          placeholder="Please type a VIN"
          name="VIN Number"
          class="form-control mb-2"
          id="vin-number"
          (input)="searchProductsFromList($event)"
        />
      </div>

      <!-- Registration Number -->
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
        <label for="registration-number">Registration Number</label>
        <input
          type="text"
          placeholder="Please type a Registration number"
          name="Plate Number"
          class="form-control mb-2"
          id="registration-number"
          (input)="searchProductsFromList($event)"
        />
      </div>

      <!-- Reset Button -->
      <div class="col-12">
        <button
          *ngIf="isFilterMode"
          (click)="resetFilter()"
          class="btn btn__main2 curved fw-500"
          style="
            float: right;
            color: #212529 !important;
            background-color: #ffc107;
            border-color: #ffc107;
          "
        >
          Reset
        </button>
      </div>
    </div>
    <!-- end -->

    <div class="card auction-content-main m-0">
      <div class="auction-content-body position-relative p-4">
        <tabset>
          <tab
            heading="Available"
            (selectTab)="tabSwitch('available')"
            [active]="activeTab === 'available' ? true : false"
          >
            <!-- Retail Table -->
            <div *ngIf="activeTab === 'available' && noFilterMode">
              <p *ngIf="!tableData.length" class="m-0">No data found</p>
              <table
                datatable
                [dtOptions]="dtOptions"
                id="retail-vehicles"
                class="row-border hover"
              >
                <thead>
                  <tr>
                    <th *ngFor="let thead of theads">{{ thead }}</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>

            <!-- Retail Filter Table-->
            <div
              class="table-responsive table-responsive--conatiner"
              *ngIf="activeTab === 'available' && isFilterMode"
            >
              <p *ngIf="!filteredData.length" class="m-0">No data found</p>
              <table datatable [dtOptions]="dtOptions2" id="retail-vehicles">
                <thead>
                  <tr>
                    <th *ngFor="let thead of theads">{{ thead }}</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </tab>

          <tab
            heading="Sold"
            (selectTab)="tabSwitch('sold')"
            [active]="activeTab === 'sold' ? true : false"
          >
            <!-- Sold Table -->
            <div
              class="table-responsive table-responsive--conatiner"
              *ngIf="activeTab === 'sold' && noFilterMode"
            >
              <p *ngIf="!tableData.length" class="m-0">No data found</p>
              <table datatable [dtOptions]="dtOptions" id="retail-vehicles">
                <thead>
                  <tr>
                    <th *ngFor="let thead of theads">{{ thead }}</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>

            <!-- Sold Filter Table -->
            <div
              class="table-responsive table-responsive--conatiner"
              *ngIf="activeTab === 'sold' && isFilterMode"
            >
              <p *ngIf="!filteredData.length" class="m-0">No data found</p>
              <table datatable [dtOptions]="dtOptions2" id="retail-vehicles">
                <thead>
                  <tr>
                    <th *ngFor="let thead of theads">{{ thead }}</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </tab>
        </tabset>
      </div>
    </div>
  </div>
</section>

<!-- <app-loader *ngIf="loading"></app-loader> -->
